import { SvgIcon, SvgIconProps } from '@mui/material'

export function WaterLevelSoilDarkIcon(props: SvgIconProps) {
  return (
    <SvgIcon role="img" viewBox="0 0 24 24" {...props}>
      <path
        clipRule="evenodd"
        d="M8 14.667a5 5 0 0 0 5-5c0-4.666-5-8.333-5-8.333S3 5.001 3 9.667a5 5 0 0 0 5 5Z"
        stroke="#99b5b4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 9.667a5 5 0 0 0 10 0s-3 1-5 0-5 0-5 0Z"
        fill="#99b5b4"
        stroke="#99b5b4"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}

export default WaterLevelSoilDarkIcon
